"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8809],{

/***/ 30597:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ItemCustomizationHelper; }
/* harmony export */ });
var ItemCustomizationHelper = /** @class */ (function () {
    function ItemCustomizationHelper() {
    }
    ItemCustomizationHelper.getOptionHelperMessages = function (max_selectable, min_selectable, options, t) {
        var message = t('common.selectAsMany');
        if (min_selectable === max_selectable && max_selectable > 0) {
            message = t('common.selectMaxSelectable', {
                maxSelectable: max_selectable
            });
        }
        else if (min_selectable < max_selectable) {
            if (min_selectable === 0) {
                message = t('common.selectUpto', {
                    uptoOptions: Math.min(max_selectable, options.length)
                });
            }
            else if (min_selectable > 0) {
                message = t('common.selectOptionRange', {
                    minSelectable: min_selectable,
                    maxSelectable: max_selectable
                });
            }
        }
        var isOptionRequired = ItemCustomizationHelper.getIsOptionRequired(min_selectable, max_selectable);
        var typeOfOption = isOptionRequired
            ? t('itemCustomization.required')
            : t('itemCustomization.optional');
        return {
            message: message,
            typeOfOption: typeOfOption
        };
    };
    ItemCustomizationHelper.getIsOptionRequired = function (min_selectable) {
        return min_selectable > 0;
    };
    ItemCustomizationHelper.isRadioButton = function (min_selectable, max_selectable) {
        var isOptionRequired = false;
        if (min_selectable === max_selectable && max_selectable > 0) {
            isOptionRequired = true;
        }
        return isOptionRequired;
    };
    return ItemCustomizationHelper;
}());


//# sourceMappingURL=helpers.js.map


/***/ }),

/***/ 24980:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ Item; }
/* harmony export */ });
var Item;
(function (Item) {
    Item["outOfStock"] = "out-of-stock";
    Item["maxSelectableReached"] = "max-selectable-reached";
})(Item || (Item = {}));


//# sourceMappingURL=item.enum.js.map


/***/ }),

/***/ 98809:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ItemCustomization; }
});

// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(36929);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/classnames/index.js
var classnames = __webpack_require__(87637);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Molecules/Dialog.js
var Dialog = __webpack_require__(95066);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Atoms/DietIndicator.js + 2 modules
var DietIndicator = __webpack_require__(10371);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Atoms/Typography.js
var Typography = __webpack_require__(87427);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Molecules/AddToCart.js
var AddToCart = __webpack_require__(2082);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Components/Organisms/ItemCustomization/Web/helpers.js
var helpers = __webpack_require__(30597);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Atoms/Radio.js
var Radio = __webpack_require__(13515);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Atoms/Checkbox.js + 2 modules
var Checkbox = __webpack_require__(59131);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/@radix-ui/react-radio-group/dist/index.module.js + 3 modules
var index_module = __webpack_require__(72710);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Atoms/Label.js
var Label = __webpack_require__(58513);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Utils/currency.util.js
var currency_util = __webpack_require__(46454);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Utils/clone.util.js
var clone_util = __webpack_require__(58316);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Enums/item.enum.js
var item_enum = __webpack_require__(24980);
;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Components/Organisms/ItemCustomization/Web/item-customization-option.component.js















function ItemCustomizationOption(_a) {
    var id = _a.id, title = _a.title, description = _a.description, max_selectable = _a.max_selectable, min_selectable = _a.min_selectable, options = _a.options, can_select_multiple_quantity = _a.can_select_multiple_quantity, _b = _a.showFoodType, showFoodType = _b === void 0 ? true : _b, setSelectedOptions = _a.setSelectedOptions, selectedOptions = _a.selectedOptions, setDialogMessage = _a.setDialogMessage;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var _c = helpers/* default.getOptionHelperMessages */.Z.getOptionHelperMessages(max_selectable, min_selectable, options, t), message = _c.message, typeOfOption = _c.typeOfOption;
    var isOptionRequired = helpers/* default.getIsOptionRequired */.Z.getIsOptionRequired(min_selectable);
    var formRef = (0,react.useRef)(null);
    var _selectedOptionsClone = (0,clone_util/* default */.Z)(selectedOptions);
    var selectedOptionsIds = _selectedOptionsClone.map(function (option) { return option.id; });
    var handleOptionChange = function (event) {
        var _a = event.target, value = _a.value, checked = _a.checked;
        var targetOption = options.find(function (option) { return option.id === Number(value); });
        //add selected option
        if (checked) {
            _selectedOptionsClone.push(targetOption);
            setDialogMessage('');
        }
        //remove deselected option
        if (!checked) {
            var deselectedOptionIds_1 = getDeselectedOptionIds(targetOption, []);
            _selectedOptionsClone = _selectedOptionsClone.filter(function (option) { return !deselectedOptionIds_1.includes(option.id); });
        }
        setSelectedOptions(_selectedOptionsClone);
    };
    var handleMultipleAddOnsChange = function (option, quantity) {
        var targetOption = _selectedOptionsClone.find(function (item) { return item.id === option.id; });
        if (targetOption) {
            targetOption.quantity = quantity;
        }
        else {
            option.quantity = quantity;
            _selectedOptionsClone.push(option);
        }
        setSelectedOptions(_selectedOptionsClone);
    };
    var getMultipleAddOnsQuantity = function (optionId) {
        var _a;
        return ((_a = selectedOptions.find(function (item) { return item.id === optionId; })) === null || _a === void 0 ? void 0 : _a.quantity) || 0;
    };
    /**
     *
     * recursively gets all nested deselected option ids
     * note: if parent option is deselected, all nested options should be deselected
     *
     */
    var getDeselectedOptionIds = function (targetOption, deselectedOptionIds) {
        deselectedOptionIds.push(targetOption.id);
        if (targetOption === null || targetOption === void 0 ? void 0 : targetOption.nested_options_group) {
            targetOption.nested_options_group.forEach(function (nestedOptionGroup) {
                var nestedOptionsGroupOptions = nestedOptionGroup.options;
                nestedOptionsGroupOptions.forEach(function (option) {
                    return getDeselectedOptionIds(option, deselectedOptionIds);
                });
            });
        }
        return deselectedOptionIds;
    };
    var getRadioDefaultValue = function () {
        for (var i = 0; i < options.length; i++) {
            if (selectedOptionsIds.includes(options[i].id)) {
                return String(options[i].id);
            }
        }
    };
    var isOptionDisabled = function (option) {
        if (option.current_stock === 0) {
            return {
                status: true,
                reason: item_enum/* Item.outOfStock */.c.outOfStock
            };
        }
        if (hasOptionGroupReachedMaxSelectable(option)) {
            if (!isOptionRequired) {
                return {
                    status: true,
                    reason: item_enum/* Item.maxSelectableReached */.c.maxSelectableReached
                };
            }
        }
        return {
            status: false,
            reason: ''
        };
    };
    var hasOptionGroupReachedMaxSelectable = function (option) {
        var selectedOptionsCount = _selectedOptionsClone.filter(function (selectedOption) {
            return selectedOption.option_group_id === option.option_group_id;
        }).length;
        if (max_selectable === -1)
            return false;
        return selectedOptionsCount >= max_selectable;
    };
    return (react.createElement("div", { id: String(id), className: "item-customization-dialog__option" },
        react.createElement("div", { className: "item-customization-dialog__option__header" },
            react.createElement(Typography/* default */.Z, { variant: "headingTwo", classes: "item-customization-dialog__option__title", weight: "semibold" }, title),
            isOptionRequired ? (react.createElement(Typography/* default */.Z, { variant: "bodyTextOne", classes: "item-customization-dialog__option__type-of-option" }, typeOfOption)) : null),
        react.createElement(Typography/* default */.Z, { variant: "bodyTextTwo", weight: "semibold", classes: "item-customization-dialog__option__message" }, message),
        react.createElement(Typography/* default */.Z, { variant: "bodyTextOne", classes: "item-customization-dialog__option__description" }, description),
        react.createElement("div", { className: "item-customization-dialog__option__list" }, can_select_multiple_quantity ? (react.createElement("form", { onChange: function (event) { return handleOptionChange(event); }, ref: formRef }, helpers/* default.isRadioButton */.Z.isRadioButton(min_selectable, max_selectable) ? (react.createElement(index_module/* RadioGroup */.Ee, { defaultValue: getRadioDefaultValue() }, options.map(function (option) { return (react.createElement("div", { key: option.id, className: (0,classnames/* default */.Z)('item-customization-dialog__option__list__item--multiple-add-on', {
                'item-customization-dialog__option__list__item--disabled': isOptionDisabled(option).status
            }) },
            react.createElement("div", { className: "item-customization-dialog__option__list__item--multiple-add-on__title" },
                showFoodType ? (react.createElement(DietIndicator/* default */.Z, { food_type: option.food_type })) : null,
                react.createElement(Label/* default */.Z, { htmlFor: String(option.id) }, option.title)),
            react.createElement(Typography/* default */.Z, { classes: "item-customization-dialog__option__list__item__price", variant: "bodyTextOne" }, isOptionDisabled(option).status &&
                isOptionDisabled(option).reason === item_enum/* Item.outOfStock */.c.outOfStock
                ? t('itemCustomization.outOfStock')
                : currency_util/* default.format */.Z.format(option.price)),
            react.createElement("div", { className: "item-customization-dialog__option__list__item--multiple-add-on__radio--wrapper" },
                react.createElement(Radio/* default */.Z, { id: String(option.id), value: String(option.id), classes: "item-customization-dialog__option__list__item--multiple-add-on__radio" })))); }))) : (options.map(function (option) { return (react.createElement("div", { key: option.id, className: (0,classnames/* default */.Z)('item-customization-dialog__option__list__item--multiple-add-on', {
                'item-customization-dialog__option__list__item--disabled': isOptionDisabled(option).status &&
                    !selectedOptionsIds.includes(option.id)
            }) },
            react.createElement("div", { className: "item-customization-dialog__option__list__item--multiple-add-on__title" },
                showFoodType ? (react.createElement(DietIndicator/* default */.Z, { food_type: option.food_type })) : null,
                react.createElement(Label/* default */.Z, { htmlFor: String(option.id) }, option.title)),
            react.createElement(Typography/* default */.Z, { classes: "item-customization-dialog__option__list__item--multiple-add-on__price", variant: "bodyTextOne" }, currency_util/* default.format */.Z.format(option.price)),
            isOptionDisabled(option).status &&
                isOptionDisabled(option).reason === item_enum/* Item.outOfStock */.c.outOfStock ? (react.createElement(Typography/* default */.Z, { classes: "item-customization-dialog__option__list__item__price", variant: "bodyTextOne" }, "t('itemCustomization.outOfStock')")) : (react.createElement(AddToCart/* default */.Z, { classes: "item-customization-dialog__option__list__item--multiple-add-on__add-to-cart", quantity: getMultipleAddOnsQuantity(option.id), itemId: option.id, onItemUpdate: function (_, count) {
                    return handleMultipleAddOnsChange(option, count);
                }, variant: "outline" })))); })))) : (react.createElement("form", { onChange: function (event) { return handleOptionChange(event); }, ref: formRef }, helpers/* default.isRadioButton */.Z.isRadioButton(min_selectable, max_selectable) ? (react.createElement(index_module/* RadioGroup */.Ee, { defaultValue: getRadioDefaultValue() }, options.map(function (option) { return (react.createElement("div", { key: option.id, className: (0,classnames/* default */.Z)('item-customization-dialog__option__list__item', {
                'item-customization-dialog__option__list__item--disabled': isOptionDisabled(option).status
            }) },
            react.createElement("div", { className: "item-customization-dialog__option__list__item__title" },
                react.createElement(Radio/* default */.Z, { id: String(option.id), value: String(option.id), classes: "item-customization-dialog__option__list__item__title__radio" }),
                showFoodType ? (react.createElement(DietIndicator/* default */.Z, { food_type: option.food_type })) : null,
                react.createElement(Label/* default */.Z, { htmlFor: String(option.id) }, option.title)),
            react.createElement(Typography/* default */.Z, { classes: "item-customization-dialog__option__list__item__price", variant: "bodyTextOne" }, isOptionDisabled(option).status &&
                isOptionDisabled(option).reason === item_enum/* Item.outOfStock */.c.outOfStock
                ? t('itemCustomization.outOfStock')
                : currency_util/* default.format */.Z.format(option.price)))); }))) : (options.map(function (option) { return (react.createElement("div", { key: option.id, className: (0,classnames/* default */.Z)('item-customization-dialog__option__list__item', {
                'item-customization-dialog__option__list__item--disabled': isOptionDisabled(option).status &&
                    !selectedOptionsIds.includes(option.id)
            }) },
            react.createElement("div", { className: "item-customization-dialog__option__list__item__title" },
                react.createElement(Checkbox/* default */.Z, { defaultChecked: selectedOptionsIds.includes(option.id), id: String(option.id), value: String(option.id), classes: "item-customization-dialog__option__list__item__title__checkbox" }),
                showFoodType ? (react.createElement(DietIndicator/* default */.Z, { food_type: option.food_type })) : null,
                react.createElement(Label/* default */.Z, { htmlFor: String(option.id) }, option.title)),
            react.createElement(Typography/* default */.Z, { classes: "item-customization-dialog__option__list__item__price", variant: "bodyTextOne" }, isOptionDisabled(option).status &&
                isOptionDisabled(option).reason === item_enum/* Item.outOfStock */.c.outOfStock
                ? t('itemCustomization.outOfStock')
                : currency_util/* default.format */.Z.format(option.price)))); })))))));
}


//# sourceMappingURL=item-customization-option.component.js.map

// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/@ant-design/icons/es/icons/Loading3QuartersOutlined.js + 1 modules
var Loading3QuartersOutlined = __webpack_require__(52004);
;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Organisms/ItemCustomization.js













/**
 * Todo
 * [] Fix deselecting options for multiple add on
 */
function ItemCustomization(_a) {
    var _this = this;
    var classes = _a.classes, item_title = _a.item_title, item_id = _a.item_id, description = _a.description, food_type = _a.food_type, item_options = _a.item_options, item_price = _a.item_price, _b = _a.can_select_multiple_quantity, can_select_multiple_quantity = _b === void 0 ? false : _b, isOpen = _a.isOpen, _c = _a.showFoodType, showFoodType = _c === void 0 ? true : _c, updateCart = _a.updateCart, _d = _a.editMode, editMode = _d === void 0 ? false : _d, editData = _a.editData, handleClose = _a.handleClose, loading = _a.loading;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var _e = (0,react.useState)(1), itemCount = _e[0], setItemCount = _e[1];
    var _f = (0,react.useState)(0.0), itemTotal = _f[0], setItemTotal = _f[1];
    var _g = (0,react.useState)(item_options), itemOptions = _g[0], setItemOptions = _g[1];
    var _h = (0,react.useState)([]), selectedOptions = _h[0], setSelectedOptions = _h[1];
    var _j = (0,react.useState)({}), requiredModifiers = _j[0], setRequiredModifiers = _j[1];
    var _k = (0,react.useState)({
        id: item_id,
        item_title: item_title,
        item_price: item_price,
        food_type: food_type,
        quantity: 1,
        options: []
    }), data = _k[0], setData = _k[1];
    var _l = (0,react.useState)(''), dialogMessage = _l[0], setDialogMessage = _l[1];
    (0,react.useEffect)(function () {
        setItemOptions(item_options);
        if (editMode)
            return;
        var defaultOptions = [];
        item_options.forEach(function (modifier) {
            if (modifier.default) {
                defaultOptions = (0,tslib_es6/* __spreadArray */.ev)((0,tslib_es6/* __spreadArray */.ev)([], defaultOptions, true), modifier.options.slice(0, modifier.max_selectable), true);
            }
        });
        defaultOptions.map(function (defaultOption) { return (defaultOption.quantity = 1); });
        setSelectedOptions(defaultOptions);
    }, [item_options]);
    (0,react.useEffect)(function () {
        var _requiredModifiersTempMap = {};
        itemOptions.forEach(function (modifier) {
            var isOptionRequired = helpers/* default.getIsOptionRequired */.Z.getIsOptionRequired(modifier.min_selectable);
            if (isOptionRequired) {
                _requiredModifiersTempMap[modifier.id] = false;
            }
        });
        setRequiredModifiers(_requiredModifiersTempMap);
    }, [itemOptions]);
    (0,react.useEffect)(function () {
        var _a;
        if (editData && editMode) {
            setData(function (_item) { return ((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, _item), editData)); });
            setItemCount((editData === null || editData === void 0 ? void 0 : editData.quantity) || 1);
            var previouslySelectedOptions_1 = [];
            var previouslySelectedOptionsIds_1 = ((_a = editData === null || editData === void 0 ? void 0 : editData.options) === null || _a === void 0 ? void 0 : _a.map(function (selectedOptions) { return selectedOptions.id; })) || [];
            var getPreviouslySelectedOptions_1 = function (options) {
                options === null || options === void 0 ? void 0 : options.forEach(function (option) {
                    var _a, _b;
                    if (previouslySelectedOptionsIds_1.includes(option.id)) {
                        option.quantity =
                            ((_b = (_a = editData === null || editData === void 0 ? void 0 : editData.options) === null || _a === void 0 ? void 0 : _a.find(function (op) { return op.id === option.id; })) === null || _b === void 0 ? void 0 : _b.quantity) ||
                                1;
                        previouslySelectedOptions_1.push(option);
                    }
                    if (option.nested_options_group &&
                        option.nested_options_group.length > 0) {
                        option.nested_options_group.forEach(function (optionGroup) {
                            getPreviouslySelectedOptions_1(optionGroup.options);
                        });
                    }
                });
            };
            item_options.forEach(function (modifier) {
                getPreviouslySelectedOptions_1(modifier.options);
            });
            setSelectedOptions(previouslySelectedOptions_1);
        }
    }, [editData, item_options]);
    (0,react.useEffect)(function () {
        var selectedOptionsIds = selectedOptions.map(function (option) { return option.id; });
        var itemOptionsIds = itemOptions.map(function (option) { return option.id; });
        var _itemOptionsClone = (0,clone_util/* default */.Z)(itemOptions);
        _itemOptionsClone.forEach(function (modifier, index) {
            modifier.options.forEach(function (option) {
                if (selectedOptionsIds.includes(option.id)) {
                    if (option.nested_options_group) {
                        option.nested_options_group.forEach(function (nestedOption) {
                            //checks if nested options group is already inserted
                            if (!itemOptionsIds.includes(nestedOption.id)) {
                                //inserts nested options group after the selected option
                                _itemOptionsClone.splice(index + 1, 0, nestedOption);
                                setTimeout(function () {
                                    scrollToSection(nestedOption === null || nestedOption === void 0 ? void 0 : nestedOption.id);
                                }, 150);
                            }
                        });
                    }
                }
                else {
                    _itemOptionsClone = _itemOptionsClone.filter(function (modifier) {
                        var _a;
                        return !((_a = option === null || option === void 0 ? void 0 : option.nested_options_group) === null || _a === void 0 ? void 0 : _a.map(function (nestedOptionGroup) { return nestedOptionGroup.id; }).includes(modifier.id));
                    });
                }
            });
        });
        setItemOptions(_itemOptionsClone);
    }, [selectedOptions]);
    (0,react.useEffect)(function () {
        generateTotal(selectedOptions);
        generateResponseData(selectedOptions, itemCount);
    }, [selectedOptions, itemCount]);
    var validateIfRequiredOptionsSelected = function () {
        var _a;
        for (var i = 0; i < selectedOptions.length; i++) {
            var optionGroupId = (_a = selectedOptions[i]) === null || _a === void 0 ? void 0 : _a.option_group_id;
            if (requiredModifiers[optionGroupId] === false) {
                requiredModifiers[optionGroupId] = true;
            }
        }
        for (var modifierId in requiredModifiers) {
            if (requiredModifiers[modifierId] === false) {
                return {
                    isValid: false,
                    requiredModifierId: modifierId
                };
            }
        }
        return {
            isValid: true,
            requiredModifierId: null
        };
    };
    var handleUpdateCart = function () { return (0,tslib_es6/* __awaiter */.mG)(_this, void 0, void 0, function () {
        var _a, isValid, requiredModifierId, requiredModifier, message, _b;
        return (0,tslib_es6/* __generator */.Jh)(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = validateIfRequiredOptionsSelected(), isValid = _a.isValid, requiredModifierId = _a.requiredModifierId;
                    if (!isValid) {
                        requiredModifier = itemOptions.find(function (modifier) {
                            return modifier.id === Number(requiredModifierId);
                        });
                        if (requiredModifier) {
                            message = "".concat(t('itemCustomization.pleaseSelect', {
                                quantity: requiredModifier.min_selectable,
                                title: requiredModifier.title
                            }), " ");
                            setDialogMessage(message);
                        }
                        setTimeout(function () {
                            scrollToSection(Number(requiredModifierId));
                        }, 500);
                        return [2 /*return*/];
                    }
                    _b = updateCart;
                    if (!_b) return [3 /*break*/, 2];
                    return [4 /*yield*/, updateCart(data)];
                case 1:
                    _b = (_c.sent());
                    _c.label = 2;
                case 2:
                    return [2 /*return*/];
            }
        });
    }); };
    var generateResponseData = function (selectedOptions, itemCount) {
        if (itemCount === 0)
            return;
        var _data = (0,clone_util/* default */.Z)(data);
        _data.quantity = itemCount;
        var selectedOptionsIds = selectedOptions.map(function (option) {
            return {
                id: option.id,
                quantity: (option === null || option === void 0 ? void 0 : option.quantity) || 1,
                title: option.title,
                price: option.price,
                food_type: option.food_type
            };
        });
        _data.options = selectedOptionsIds;
        setData(_data);
    };
    var generateTotal = function (selectedOptions) {
        var total = selectedOptions.reduce(function (acc, option) {
            return acc + option.price * ((option === null || option === void 0 ? void 0 : option.quantity) || 1);
        }, 0);
        setItemTotal(item_price + total * itemCount);
    };
    var scrollToSection = function (sectionId) {
        var dialogBody = document.getElementById('dialog__body');
        var section = document.getElementById(String(sectionId));
        if (dialogBody && section) {
            dialogBody === null || dialogBody === void 0 ? void 0 : dialogBody.scrollTo({
                top: (section === null || section === void 0 ? void 0 : section.getBoundingClientRect().top) -
                    (dialogBody === null || dialogBody === void 0 ? void 0 : dialogBody.getBoundingClientRect().top),
                behavior: 'smooth'
            });
        }
    };
    return (react.createElement(Dialog/* default */.Z, { onClose: handleClose, isOpen: isOpen, title: react.createElement("div", { className: "item-customization-dialog__title" },
            react.createElement(DietIndicator/* default */.Z, { food_type: food_type }),
            react.createElement(Typography/* default */.Z, { variant: 'headingOne' }, item_title)), subTitle: react.createElement("div", { className: "item-customization-dialog__sub-title" },
            react.createElement(Typography/* default */.Z, { classes: "item-customization-dialog__sub-title-text", variant: 'bodyTextOne' }, description)), footer: react.createElement(react.Fragment, null,
            react.createElement("div", { className: "item-customization-dialog__footer" },
                dialogMessage ? (react.createElement(Typography/* default */.Z, { classes: "item-cusomization-dialog__footer__message", variant: 'bodyTextOne' }, dialogMessage)) : null,
                react.createElement("div", { className: "item-customization-dialog__footer__content" },
                    react.createElement("div", { className: "item-customization-dialog__footer__add-to-cart", onClick: handleUpdateCart },
                        react.createElement("div", { className: "item-customization-dialog__footer__add-to-cart__left" },
                            react.createElement(Typography/* default */.Z, { classes: "item-customization-dialog__footer__add-to-cart__text", variant: 'bodyTextOne' }, "".concat(t('itemCustomization.total'), " ").concat(currency_util/* default.format */.Z.format(itemTotal)))),
                        react.createElement(Typography/* default */.Z, { classes: "item-customization-dialog__footer__add-to-cart__text", variant: 'bodyTextOne' }, editMode
                            ? t('itemCustomization.updateItem')
                            : t('itemCustomization.addItem')))))), classes: (0,classnames/* default */.Z)('item-cusomization-dialog', classes) },
        react.createElement("div", { className: "item-customization-dialog__content" }, loading ? (react.createElement(Loading3QuartersOutlined/* default */.Z, { spin: true, className: "item-customization-dialog__loader" })) : (itemOptions === null || itemOptions === void 0 ? void 0 : itemOptions.map(function (item_option) { return (react.createElement(ItemCustomizationOption, (0,tslib_es6/* __assign */.pi)({ key: item_option.id }, item_option, { can_select_multiple_quantity: can_select_multiple_quantity, showFoodType: showFoodType, collectSelectedOptions: function () { }, setSelectedOptions: setSelectedOptions, selectedOptions: selectedOptions, setDialogMessage: setDialogMessage }))); })))));
}


//# sourceMappingURL=ItemCustomization.js.map


/***/ })

}]);